"use client";

import { CheckIcon } from "../CheckIcon";

const BULLETS = [
  "Answer a few simple questions about your business.",
  "Get a tailored recommendation based on your needs.",
  "Choose your next step—speak to an expert, take action today, or save for later.",
];


export function RegisterIntroStep({ onStart }: { onStart: () => void }) {
  return (
    // On phones the content is short enough to sit in the middle of the screen
    // rather than hugging the top: min-height fills the viewport below the 64px
    // nav and justify-center centres within it, with symmetric py so the
    // centring isn't skewed. dvh, not vh, so mobile browsers' collapsing
    // address bar doesn't offset it. min-h (not h) means a step taller than the
    // screen still just grows and scrolls normally. Reverts to top-aligned
    // from sm up.
    <div className="mx-auto flex min-h-[calc(100dvh-64px)] w-full max-w-[932px] flex-col items-start justify-center gap-6 px-4 py-10 sm:min-h-0 sm:justify-start sm:gap-8 sm:px-6 sm:pb-24 sm:pt-16 lg:pt-[158px]">
      <div className="flex max-w-[595px] flex-col items-start gap-3 sm:gap-[17px]">
        <h1 className="font-suisse-intl-bold text-[32px] leading-tight text-white sm:text-5xl lg:text-[64px] lg:leading-[71px]">
          Let&apos;s get started
        </h1>
        <p className="font-suisse-intl-medium text-base leading-relaxed text-white sm:text-lg sm:leading-[28.8px]">
          A few quick steps, and you&apos;re on your way!
        </p>
      </div>

      <div className="flex w-full flex-col items-start gap-4">
        <h2 className="font-suisse-intl-bold text-2xl capitalize leading-tight text-white sm:text-[32px]">
          Register my business
        </h2>
        <ul className="flex w-full flex-col items-start gap-3 sm:gap-2">
          {BULLETS.map((bullet) => (
            <li key={bullet} className="flex items-start gap-2">
              <CheckIcon />
              {/* mt-0 on mobile: the icon's own mt-[5px] already lines it up
                  with a 26px line, and the extra nudge pushed it off. */}
              <span className="font-suisse-intl text-base leading-[26px] text-white/80 sm:mt-1 sm:text-lg sm:leading-[28.8px]">
                {bullet}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* Full-width on phones — a ~120px pill in a left-aligned column is an
          easy primary action to miss. */}
      <button
        type="button"
        onClick={onStart}
        className="flex h-12 w-full items-center justify-center rounded-full bg-white px-4 font-suisse-intl text-xl leading-5 text-[#2A4775] transition-opacity hover:opacity-90 sm:w-auto sm:min-w-[160px]"
      >
        Start Now
      </button>
    </div>
  );
}
